<template>
  <section :class="{ 'modal-backdrop': modals.length }">
    <transition-group name="modal">
      <component
        v-for="(modal, index) in modals"
        :key="modal.component.name"
        :is="modal.component"
        v-bind:close="modal.close"
        v-bind:dismiss="modal.dismiss"
        v-bind="modal.props"
        :class="{ 'd-block': modal.component, 'faded': index !== modals.length - 1 }"
      />
    </transition-group>
  </section>
</template>

<script>
import ModalService from '../services/modal.service';
import Modal from './Modal.vue';
export default {
  components: { Modal },
  data() {
    return {
      modals: [],
    }
  },
  created() {
    ModalService.$on('open', ({ component, props, resolve, reject }) => {
      document.getElementsByTagName('body')[0].classList.add('modal-open')
      this.modals.push({
        component,
        props,
        close: value => {
            const index = this.modals.findIndex(item => item.component == component)
            if(index != -1) {
                this.modals.splice(index, 1)
            }
            if(this.modals.length === 0){
                document.getElementsByTagName('body')[0].classList.remove('modal-open')
            }
          resolve(value);
        },
        dismiss: reason => {
          const index = this.modals.findIndex(item => item.component == component)
          if(index != -1) {
            this.modals.splice(index, 1)
          }
          if(this.modals.length === 0){
                document.getElementsByTagName('body')[0].classList.remove('modal-open')
          }
          reject(reason);
        },
      });
    });
  }
}
</script>

<style lang="sass" scoped>
.modal-backdrop
    position: fixed
    top: 0
    bottom: 0
    left: 0
    right: 0
    background-color: rgba(0, 0, 0, 0.3)
    display: flex
    justify-content: center
    align-items: center
    z-index: 100
    .faded
        opacity: .1
.modal-enter-active,.modal-leave-active
  transition: opacity .5s ease
.modal-enter,.modal-leave-to
  opacity: 0
</style>
